import KeenSlider from 'keen-slider'
import { navigation } from './slider-plugins-new'

const initSlider = () => {
  const sliders = document.querySelectorAll('.keen-slider')

  if (!sliders?.length) return

  const animation = { duration: 10000, easing: (t) => t }

  sliders.forEach((slider) => {
    const config = {
      drag: slider.classList.contains('slider--grab'),
      loop: slider.classList.contains('slider--loop'),
      mode: slider.classList.contains('slider--snap') ? 'snap' : 'free',
      renderMode: 'performance',

      slides: {
        origin: 'center',
        perView: slider.dataset.cols,
        spacing: slider.dataset.cols == 3 ? 0 : 16,
      },
      ...(Number(slider.dataset.cols) === 3 && {
        breakpoints: {
          '(max-width: 1024px)': {
            slides: {
              perView: 2,
            },
          },

          '(max-width: 640px)': {
            slides: {
              perView: 1,
            },
          },
        },
      }),
    }

    if (slider.classList.contains('slider--auto')) {
      config.created = (s) => s.moveToIdx(5, true, animation)
      config.updated = (s) => s.moveToIdx(s.track.details.abs + 5, true, animation)
      config.animationEnded = (s) => s.moveToIdx(s.track.details.abs + 5, true, animation)
    }

    new KeenSlider(slider, config, [
      navigation({
        arrows: slider.classList.contains('slider--arrows'),
        dots: slider.classList.contains('slider--dots'),
      }),
    ])
  })
}

initSlider()
